




























import { Vue, Component } from 'vue-property-decorator';
import { ProgramDetail, PersonalDetail } from './api';
import * as config from './config';
import Rank from './components/Rank.vue';
import { ImagePreview } from 'vant';
@Component({
  components: {
    Rank,
  },
})
export default class Detail extends Vue {
  option = config.OPTHINES;
  detail: any = {};
  async created() {
    if (this.$route.query.type === 'Three') {
      const id = this.$route.query.id;
      const res = await PersonalDetail(this.option.voteName, id);
      this.detail = res.data;
    } else {
      const id = this.$route.query.id;
      const res = await ProgramDetail(this.option.voteName, id);
      this.detail = res.data;
    }
  }
  showImage(e: any) {
    ImagePreview([e]);
  }
}
